import { Route } from '@angular/router';
import { isOnlineMedicalNetworkGuard } from './helpers/guards/is-only-medical-network.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    path: 'services',
    loadChildren: () => import('./pages/medical-network/core-medical-network/core-medical-network.module').then((module) => module.CoreMedicalNetworkModule)
  },
  {
    path: 'subscription',
    loadChildren: () => import('./pages/subscription-plans/core-subscription-plans/core-subscription-plans.module').then((module) => module.CoreSubscriptionPlansModule)
  },
  {
    path: '',
    canActivate: [isOnlineMedicalNetworkGuard],
    loadChildren: () => import('./pages/public/core-public/core-public.module').then((module) => module.CorePublicModule)
  },
  {
    path: '',
    canActivate: [isOnlineMedicalNetworkGuard],
    loadChildren: () => import('./pages/private/core-private/core-private.module').then((module) => module.CorePrivateModule)
  },
  {
    path: '',
    loadChildren: () => import('@fh-client-interaction-frontends/fh-fallbacks').then((feature) => feature.FhFallbacksModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('@fh-client-interaction-frontends/cp-personal-area').then((module) => module.CpPersonalAreaModule),
    outlet: 'user-data',
    data: {
      title: '',
      description: '',
      feature: 'personal-area-menu',
      fhSideBarConfigs: {
        widthChangedEmitter: '500px',
        configHeaderEmitter: {
          navigateBackButton: false,
          outlet: 'user-data',
          parentNavigation: null
        }
      }
    }
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/not-found'
  }
];
